import {changeOrderAgency} from '@/api/order'
import {mapState} from 'vuex'

export default {
  data() {
    return {
    }
  },
  computed: {
  },
  mounted(){

  },
  methods: {
    changeReferrerAgency(params){
      params ={}
      let {ref_agency_id} = this.formData
      let {order_id} = this.$route.query
      params ={
        ref_agency_id,
        order_id
      }
      this.mixinSourceNetwork().changeOrderAgency(params)
    },
    mixinSourceNetwork(){
      return{
        changeOrderAgency:async (params)=>{
          let {data} = await changeOrderAgency(params)
        }
      }
    }
  }
}
